import HeroSection from '../features/HeroSection';
import HardwareShowcase from '../features/HardwareShowcase';
import SoftwareBanner from '../features/SoftwareBanner';

export default function Home() {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
     {/* 顶部主视觉区 */}
     <HeroSection />
      
      {/* 硬件双列展示区 */}
      <HardwareShowcase />
      
      {/* 第三部分：Q-Synergy 软件中枢平台展示区 */}
      <SoftwareBanner />
    </div>
  );
}